import React from 'react'
import { Button } from '../../../components/shadcn/Button'
import { ProcessStatusIcon } from '../../../components/ProcessStatusIcon'
import { translate } from '../../../lib'
import { DateFormatted } from '../../../components/DateFormatted'
import { graphql, useFragment } from '../../../gql'
import { useOrderDetailContext } from '../OrderDetailContext'

const OrderStateHistory_OrderFragment = graphql(`
  fragment OrderStateHistory_OrderFragment on Order {
    id
    processStatusRelations {
      status {
        id
      }
      created
      createdBy {
        name
        email
      }
      note
    }
  }
`)

type StatusColorConfig = {
  bg: string
  text: string
  button: string
}

export const statusColors: Record<string, StatusColorConfig> = {
  received: {
    bg: 'bg-cloud-blue',
    text: 'text-primary-blue',
    button: 'bg-primary-blue border-primary-blue',
  },
  recieved: {
    bg: 'bg-cloud-blue',
    text: 'text-primary-blue',
    button: 'bg-primary-blue border-primary-blue',
  }, // server typo
  picking: {
    bg: 'bg-violet',
    text: 'text-purple',
    button: 'bg-purple border-purple',
  },
  packing: {
    bg: 'bg-indigo',
    text: 'text-indigo-dark',
    button: 'bg-indigo-dark border-indigo-dark',
  },
  packed: {
    bg: 'bg-sky-light',
    text: 'text-sky-blue',
    button: 'bg-sky-blue border-sky-blue',
  },
  dispatched: {
    bg: 'bg-orange-light',
    text: 'text-orange',
    button: 'bg-orange border-orange-light',
  },
  delivered: {
    bg: 'bg-green-light',
    text: 'text-green',
    button: 'bg-green border-green',
  },
  returned: {
    bg: 'bg-red-light',
    text: 'text-red',
    button: 'bg-red border-red',
  },
  picking_error: {
    bg: 'bg-red-light',
    text: 'text-red',
    button: 'bg-red border-red',
  },
  cancelled: {
    bg: 'bg-red-light',
    text: 'text-red',
    button: 'bg-red border-red',
  },
}

export const OrderStateHistory: React.FC = () => {
  const context = useOrderDetailContext()
  const order = useFragment(OrderStateHistory_OrderFragment, context.order)

  return (
    <div className={'flex flex-col gap-4'}>
      <h1 className={'text-black text-2xl font-bold'}>Historie stavů</h1>
      <div className={'box flex flex-col gap-3'}>
        {order.processStatusRelations.map(ps => {
          const statusId = ps.status.id
          const colors = statusColors[statusId] || statusColors.received

          return (
            <div
              key={`${order.id}-${statusId}-${ps.created}-${ps.createdBy?.email}-${Math.random() * 999}`}
              className={`p-4 flex justify-between items-center rounded-md ${colors.bg}`}>
              <div className={'flex items-center gap-3'}>
                <Button variant="secondary" size="icon" className={`text-white pointer-events-none ${colors.button}`}>
                  <ProcessStatusIcon status={statusId} size="lg" />
                </Button>
                <div>
                  <h1 className={`text-sm ${colors.text} font-semibold`}>{translate(statusId)}</h1>
                  <h1 className={`text-xs ${colors.text} font-normal`}>
                    <DateFormatted date={ps.created} hoursAndMins={true} />
                  </h1>
                </div>
              </div>
              <div className={'flex flex-col'}>
                {ps.createdBy && ps.createdBy.name?.length > 0 && (
                  <h1 className={`text-sm ${colors.text} font-semibold`}>
                    {ps.createdBy?.name || ''} ({ps.createdBy?.email || ''})
                  </h1>
                )}
                <h1 className={`text-xs ${colors.text} font-normal self-end`}>{ps.note ? `Pozn: ${ps.note}` : ''}</h1>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
